import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './core/http.service';
import { ResponseData } from './model/response.model';
import { URLService } from './_url.service';
@Injectable({
  providedIn: 'root'
})

export class UserService {

  constructor(private httpService: HttpService, private URLService: URLService) { }

  getEmployeesList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetEmployeesListUrl, filterModel);
  }


  getUserDetails(userId: number): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetUserDetailsUrl, { userId: userId });
  }

  UpdateUserProfile(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.UpdateUserProfileUrl, model);
  }

  DeleteUser(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.DeleteUserUrl, model);
  }

  ChangeUserPassword(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.ChangeUserPasswordUrl, model);
  }

  GetCustomersList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetCustomersListUrl, filterModel);
  }

  GetBasicWalkInCustomersList(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetBasicWalkInCustomersListUrl, filterModel);
  }


  ValidateEmiratesId(emiratesId: string): Observable<ResponseData> {
    return this.httpService.get(this.URLService.ValidateEmiratesIdUrl, { emiratesId: emiratesId });
  }

  UpdateWalkInBasicUserProfile(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.UpdateWalkInBasicUserProfileUrl, model);
  }

  CreateWalkInUser(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.CreateWalkInUserUrl, model);
  }

  GetAllSystemRoles(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllSystemRolesUrl);
  }

  CreateUser(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.CreateUserUrl, model);
  }

  CreateCustomer(model: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.CreateCustomerUrl, model);
  }

  GetMyUsers(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetMyUsersUrl);
  }

  GetMyAuditUsers(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetMyAuditUsersUrl);
  }

  GetCustomerInquiry(filterModel: any): Observable<ResponseData> {
    return this.httpService.post(this.URLService.GetCustomerInquiryUrl, filterModel);
  }

  GetDashboards(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetDashboardsUrl);
  }

     GetDashboardData(fromDate: string, toDate: string): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetDashboardData,{fromDate:fromDate,toDate:toDate});
  }

     GetDashboardPopupReport(fromDate: string, toDate: string, reportPeriod: string, year: string, month: string, reportName: string, implementation?: string, service?: string,serviceCategory?:string): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetDashboardPopupReport,{fromDate:fromDate,toDate:toDate,reportPeriod:reportPeriod, year:year, month:month, reportName:reportName, implementation: implementation ?? '', service: service ?? '', serviceCategory: serviceCategory ?? '' });
    
  }

   GetAllSevice(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllSevice);
  }
     GetAllImplementation(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllImplementation);
  }

   GetAllCategory(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllCategory);
  }
   GetAllCustomer(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllCustomer);
  }

  GetAllEmployee(): Observable<ResponseData> {
    return this.httpService.get(this.URLService.GetAllEmployee);
  }

    // GetServiceStatusAndTotalEarningForDashboards(fromDate: string, toDate: string): Observable<ResponseData> {
  //   return this.httpService.get(this.URLService.GetServiceStatusAndTotalEarningForDashboards,{fromDate:fromDate,toDate:toDate});
  // }

  // GetCategoryWiseIncomePerQuarterReport(): Observable<ResponseData> {
  //   return this.httpService.get(this.URLService.GetCategoryWiseIncomePerQuarterReport);
  // }  

  //   GetMonthlySubmittedOrdersChartsForDashboards(fromDate: string, toDate: string): Observable<ResponseData> {
  //   return this.httpService.get(this.URLService.GetMonthlySubmittedOrdersChartsForDashboards,{fromDate:fromDate,toDate:toDate});

  // }

  
}
